<script setup>
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16.636" height="25" viewBox="0 0 16.636 25">
    <g id="Icon_feather-award" data-name="Icon feather-award" transform="translate(-6.5 -0.5)">
      <path id="Path_3974" data-name="Path 3974" d="M22.136,8.818A7.318,7.318,0,1,1,14.818,1.5a7.318,7.318,0,0,1,7.318,7.318Z" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      <path id="Path_3975" data-name="Path 3975" d="M11.765,20.83,10.5,30.355l5.227-3.136,5.227,3.136L19.69,20.82" transform="translate(-0.909 -5.855)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    </g>
  </svg>
</template>
